module.exports = __webpack_public_path__ + "static/media/endExtraChallenge.099ed110.svg";